import React from 'react';
import { Helmet } from 'react-helmet-async';
import LandingHeader from './components/LandingHeader';
import Hero from './components/Hero';
import Features from './components/Features';
import Roles from './components/Roles';
import HowItWorks from './components/HowItWorks';
import SocialProof from './components/SocialProof';
import Pricing from './components/Pricing';
import FinalCTA from './components/FinalCTA';
import Footer from '../../components/Footer';

export default function LandingPage() {
  return (
    <>
      <Helmet>
        <title>SkillBinder — Career growth that actually fits your job</title>
        <meta 
          name="description" 
          content="Personalized plans, exercises, salary by ZIP, and resume builder for nurses, hairdressers, trades, business, and tech." 
        />
        <meta property="og:title" content="SkillBinder — Career growth that actually fits your job" />
        <meta property="og:description" content="Personalized plans, exercises, salary by ZIP, and resume builder." />
        <meta property="og:image" content="/assets/images/CareerLift_Logo-1757425914868.png" />
        <meta name="theme-color" content="#2285C8" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <LandingHeader />
        <main>
          <Hero />
          <Features />
          <Roles />
          <HowItWorks />
          <SocialProof />
          <Pricing />
          <FinalCTA />
        </main>
        <Footer 
          privacyUrl="/privacy-policy" 
          termsUrl="/terms-of-service" 
          contactUrl="/contact-page" 
        />
      </div>
    </>
  );
}